/**
 * 心情管理
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { message } from 'antd';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { TableActionType as ta } from '@/util/enum';
import model from '@/reducers/client/baseset/mood/model';
import { showConfirm } from '@/components/xqxc_ui';
import { State } from './types';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        pageNum: 1,
        pageSize: 10,
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match);
    }

    // 查询
    _searchHandle = (useCache) => {
        const { pageNum, pageSize } = this.state;
        this.searchCache = {
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        const { history } = this.props;
        switch (type) {
            case ta.detail:
                history.push({ pathname: '/home/client/baseset/mood/detail/' + key });
                break;
            case ta.edit:
                history.push({ pathname: '/home/client/baseset/mood/edit/' + key });
                break;
            case ta.state:
                showConfirm(`是否${State[key]}？`, '', () => {
                    http('/?cmd=com.xqxc.api.pig.mis.biz.user.MaterialMisService.updateStatus', { id: item.id, status: key }, 'POST')
                        .then(() => {
                            message.success(`${State[key]}成功!`);
                            this._searchHandle('useCache');
                        }).catch((reject) => message.error(reject.message));
                });
                break;
        }
    }

    render() {
        const { tableSource } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <TableList renderData={tableSource} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object, // 路由match对象
    getTableSource: PropTypes.func,
    tableSource: PropTypes.array,
    setBreadcrumbPaths: PropTypes.func,
};
const mapStateToProps = (state) => ({
    tableSource: state.baseset_mood.tableSource,
});

export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);